<template>
    <div>
        <transition name="fade">
            <Row v-if="mainTable.sarchCardShow" :gutter="16">
                <Col span="24">
                    <search-card
                        :form="mainTable.searchForm"
                        :table-load-event="getMainTableRecords"
                        :table-search="mainTable.tableSearch"
                        :colSpan="4"
                        :searchBtnColSpan="4"
                    />
                </Col>
            </Row>
        </transition>

        <Card>
            <Spin v-if="innerSpin" size="large" fix></Spin>
            <Row :gutter="16">
                <Col span="24">
                    <div class="global-tool-bar">
                        <div class="left-bar">
                            <span class="title">产品管理</span>
                        </div>
                        <div class="right-bar">
                            <Button
                                v-if="$checkAccessArray(['B', 'C'])"
                                type="warning"
                                size="small"
                                class="btns"
                                shape="circle"
                                @click="batchUpdateProductForNotShow"
                                >批量隐藏产品</Button
                            >
                            <Button
                                type="info"
                                v-if="$checkAccessArray(['B', 'C'])"
                                size="small"
                                class="btns"
                                shape="circle"
                                @click="showAllProducts"
                                >显示隐藏产品</Button
                            >
                            <Button
                                v-if="$checkAccessArray(['B', 'C'])"
                                size="small"
                                class="btns"
                                shape="circle"
                                type="success"
                                icon="ios-add-circle-outline"
                                @click="onCreate"
                                >新增</Button
                            >
                            <!-- <Button v-if="$checkAccessArray(['B', 'C'])"
                            size="small"
                            class="btns"
                             type="info"
                            shape="circle"
                            @click="onCreateBytemplate">按模板新增</Button> -->
                            <Button
                                v-if="$checkAccessArray(['B', 'C'])"
                                size="small"
                                class="btns"
                                type="primary"
                                shape="circle"
                                @click="onBaseBathEdit"
                                >批量编辑基础信息</Button
                            >
                            <Button
                                v-if="$checkAccessArray(['B', 'C'])"
                                size="small"
                                class="btns"
                                shape="circle"
                                type="info"
                                @click="onBathEdit"
                                >批量编辑说明信息</Button
                            >
                            <Button
                                type="primary"
                                size="small"
                                class="btns"
                                shape="circle"
                                icon="ios-search"
                                @click="
                                    mainTable.sarchCardShow =
                                        !mainTable.sarchCardShow
                                "
                                >搜索</Button
                            >
                            <Button
                                type="info"
                                size="small"
                                class="btns"
                                shape="circle"
                                @click="onExport()"
                                >导出</Button
                            >
                        </div>
                    </div>
                </Col>
            </Row>

            <Row :gutter="16">
                <Col span="24">
                    <stand-pagination-table
                        ref="mainTable"
                        :columns="mainTable.tableColumns"
                        :data="mainTable.tableData"
                        :loading="mainTable.tableLoading"
                        :table-search="mainTable.tableSearch"
                        @on-selection-change="onSelectionChange"
                        :table-load-event="getMainTableRecords"
                    />
                </Col>
            </Row>
        </Card>

        <ProductPopupEdit
            v-model="popupEditModalShow"
            :popup-edit-resource="popupEditResource"
            :product-uuid="popupEditProductUuid"
            :product-code="popupEditproductCode"
            @on-popup-submit-finish="popupSubmitFinish"
            ref="productPopupEdit"
        />

        <ProductPopupEditBath
            v-model="popupEditModalBathShow"
            :popup-edit-resource="popupEditResource"
            :productUuidsBathEdit="productUuidsBathEdit"
        />

        <ProductPopupEditBaseBath
            :popup-edit-resource="popupEditResource"
            v-model="popupEditModalBaseBathShow"
            :productUuidsBathEdit="productUuidsBathEdit"
        />
        <ProductPopupInsertTemplate
            v-model="popupEditModalInsertTemplateShow"
            @insert-by-template="insertByTemplate"
        />

        <Modal v-model="blockDistModal.show" width="60" title="禁售区域">
            <Form label-position="top">
                <Row :gutter="16">
                    <Col span="6">
                        <FormItem label="省份">
                            <Select
                                v-model="blockDistModal.form.provinceUuid"
                                @on-change="onBlockProvinceChange"
                            >
                                <Option
                                    v-for="p in popupEditResource.provinceOptions"
                                    :key="p.regionUuid"
                                    :value="p.regionUuid"
                                    >{{ p.regionName }}</Option
                                >
                            </Select>
                        </FormItem>
                    </Col>

                    <Col span="6">
                        <FormItem label="城市">
                            <Select
                                v-model="blockDistModal.form.cityUuid"
                                @on-change="onBlockCityChange"
                            >
                                <Option
                                    v-for="c in blockDistModal.cityOptions"
                                    :key="c.regionUuid"
                                    :value="c.regionUuid"
                                    >{{ c.regionName }}</Option
                                >
                            </Select>
                        </FormItem>
                    </Col>

                    <Col span="6">
                        <FormItem label="区域">
                            <Select v-model="blockDistModal.form.distUuid">
                                <Option
                                    v-for="d in blockDistModal.distOptions"
                                    :key="d.regionUuid"
                                    :value="d.regionUuid"
                                    >{{ d.regionName }}</Option
                                >
                            </Select>
                        </FormItem>
                    </Col>

                    <Col span="4">
                        <FormItem label="类型">
                            <Select v-model="blockDistModal.form.blockType">
                                <Option
                                    v-for="t in ['预售', '现售']"
                                    :key="t"
                                    :value="t"
                                    >{{ t }}</Option
                                >
                            </Select>
                        </FormItem>
                    </Col>

                    <Col span="2">
                        <FormItem label=" ">
                            <Button type="primary" @click="onAddProductBlock"
                                >添加</Button
                            >
                        </FormItem>
                    </Col>
                </Row>
            </Form>

            <Row :gutter="16">
                <Col span="24">
                    <Table
                        :columns="blockDistModal.table.columns"
                        size="small"
                        :data="blockDistModal.table.rows"
                        stripe
                        border
                    />
                </Col>
            </Row>

            <div slot="footer">
                <Button type="primary" @click="onSetProductBlock">保存</Button>
            </div>
        </Modal>

        <Modal v-model="privateSaleModal.show" width="60" title="专售页">
            <Form label-position="top">
                <Row :gutter="16">
                    <Col span="6">
                        <FormItem label="客户">
                            <Select
                                v-model="privateSaleModal.customerUuid"
                                filterable
                            >
                                <Option
                                    v-for="p in externalCustomerUsers"
                                    :key="p.userUuid"
                                    :value="p.userUuid"
                                    >{{ p.userPersonName }} （{{
                                        p.userName
                                    }}）</Option
                                >
                            </Select>
                        </FormItem>
                    </Col>

                    <Col span="2">
                        <FormItem label=" ">
                            <Button type="primary" @click="onAddPrivateSale"
                                >添加</Button
                            >
                        </FormItem>
                    </Col>
                </Row>
            </Form>

            <Row :gutter="16">
                <Col span="24">
                    <Table
                        :columns="privateSaleModal.table.columns"
                        size="small"
                        :data="privateSaleModal.table.rows"
                        stripe
                        border
                    />
                </Col>
            </Row>

            <div slot="footer">
                <Button type="primary" @click="onUpdatePrivateSale"
                    >保存</Button
                >
            </div>
        </Modal>

        <Modal
            v-model="commissionDistModal.show"
            width="60"
            title="特定区域提成"
        >
            <Form label-position="top">
                <Row :gutter="16">
                    <Col span="4">
                        <FormItem label="省份">
                            <Select
                                v-model="commissionDistModal.form.provinceUuid"
                                @on-change="onCommissionProvinceChange"
                            >
                                <Option
                                    v-for="p in popupEditResource.provinceOptions"
                                    :key="p.regionUuid"
                                    :value="p.regionUuid"
                                    >{{ p.regionName }}</Option
                                >
                            </Select>
                        </FormItem>
                    </Col>

                    <Col span="4">
                        <FormItem label="城市">
                            <Select
                                v-model="commissionDistModal.form.cityUuid"
                                @on-change="onCommissionCityChange"
                            >
                                <Option
                                    v-for="c in commissionDistModal.cityOptions"
                                    :key="c.regionUuid"
                                    :value="c.regionUuid"
                                    >{{ c.regionName }}</Option
                                >
                            </Select>
                        </FormItem>
                    </Col>

                    <Col span="4">
                        <FormItem label="区域">
                            <Select v-model="commissionDistModal.form.distUuid">
                                <Option
                                    v-for="d in commissionDistModal.distOptions"
                                    :key="d.regionUuid"
                                    :value="d.regionUuid"
                                    >{{ d.regionName }}</Option
                                >
                            </Select>
                        </FormItem>
                    </Col>

                    <Col span="4">
                        <FormItem label="类型">
                            <Select
                                v-model="
                                    commissionDistModal.form.commissionType
                                "
                            >
                                <Option
                                    v-for="t in ['预售', '现售']"
                                    :key="t"
                                    :value="t"
                                    >{{ t }}</Option
                                >
                            </Select>
                        </FormItem>
                    </Col>

                    <Col span="4">
                        <FormItem label="提成">
                            <decimal-input
                                v-model="
                                    commissionDistModal.form.commissionValue
                                "
                                :precision="4"
                                :min="0"
                            />
                        </FormItem>
                    </Col>

                    <Col span="2">
                        <FormItem label=" ">
                            <Button type="primary" @click="onAddCommission"
                                >添加</Button
                            >
                        </FormItem>
                    </Col>
                </Row>
            </Form>

            <Row :gutter="16">
                <Col span="24">
                    <Table
                        :columns="commissionDistModal.table.columns"
                        size="small"
                        :data="commissionDistModal.table.rows"
                        stripe
                        border
                    />
                </Col>
            </Row>

            <div slot="footer">
                <Button type="primary" @click="onSetSpecailCommission"
                    >保存</Button
                >
            </div>
        </Modal>
    </div>
</template>

<script>
import SearchCard from "@/components/searchCard/searchCard.vue";
import StandPaginationTable from "@/components/standard-pagination-table/StandPaginationTable";
import search from "@/libs/search";
import { singleImageRender } from "@/libs/tableRowImageRender";
import DecimalInput from "@/components/number-input/decimal-input";
import {
    productApprovalColor,
    productApprovalFormat
} from "@/view/product-management/product-management/ProductApproveDefine";
import {
    FORM_EDIT_MODE_CREATE,
    FORM_EDIT_MODE_MODIFY
} from "@/view/mixins/form-edit-mode";
import ProductPopupEdit from "./product-popup-edit-Tab";
import ProductPopupEditBath from "./product-popup-edit-Tab-Bath";
import ProductPopupEditBaseBath from "./product-popup-edit-Base-Bath";
import ProductPopupInsertTemplate from "./product-popup-Insert-Template";

import {
    getProductBlockDist,
    getProductList,
    updateProductForShow,
    deleteProductByUuid,
    getProductPrivateCustomer,
    pageInit4ProductEdit,
    saveProductBlockDist,
    updateProductPrivateSale,
    getProductSpecialCommission,
    saveProductSpecialCommission,
    setProductTop,
    updateProductDisplayOrder,
    syncYsProduct
} from "@/api/modules/product-management/product-management";
import {
    getResource,
    setResource
} from "@/view/product-management/product-management/ProductPopupHelper";
import { getExternalCustomerUserList } from "@/api/modules/account-management/externalCustomer-user-management";
import { DOWNLOAD_SERVER } from "@/api/modules/files";

export default {
    name: "productList",
    components: {
        StandPaginationTable,
        SearchCard,
        ProductPopupEdit,
        ProductPopupEditBath,
        ProductPopupEditBaseBath,
        ProductPopupInsertTemplate,
        DecimalInput
    },
    props: {
        readOnly: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            innerSpin: false,
            isShowAllPros: true,
            //产品排序
            productOrder: 0,
            mainTable: {
                tableColumns: [
                    { type: "selection", width: 60, align: "center" },
                    {
                        title: "行号",
                        type: "index",
                        width: 60,
                        align: "center"
                    },
                    {
                        title: "苗场",
                        key: "seedFarmName",
                        align: "center",
                        excel: true
                    },
                    {
                        title: "大类",
                        key: "mainCategoryName",
                        align: "center",
                        excel: true
                    },
                    {
                        title: "小类",
                        key: "subCategoryName",
                        align: "center",
                        excel: true
                    },
                    {
                        title: "品牌",
                        key: "brandName",
                        align: "center",
                        excel: true
                    },
                    {
                        title: "编号",
                        key: "productCode",
                        align: "center",
                        excel: true
                    },
                    {
                        title: "名称",
                        key: "productName",
                        width: 160,
                        align: "center",
                        excel: true
                    },
                    {
                        title: "单位",
                        key: "unitName",
                        align: "center",
                        excel: true
                    },
                    {
                        title: "形态",
                        key: "productForm",
                        align: "center",
                        excel: true
                    },
                    {
                        title: "规格",
                        key: "productSpec",
                        width: 100,
                        ellipsis: true,
                        align: "center",
                        excel: true
                    },
                    {
                        title: "价格",
                        key: "productPreSalePrice",
                        align: "center",
                        excel: true
                    },
                    {
                        title: "排序",
                        key: "productDisplayOrder",
                        align: "center",
                        width: 80,
                        renderHeader: (h, { column, index }) => {
                            return h("div", [
                                h("span", {}, column.title),
                                h("icon", {
                                    props: {
                                        type: this.productOrderIcon,
                                        size: 16
                                    },
                                    style: {
                                        marginLeft: "4px"
                                    },
                                    on: {
                                        click: () => {
                                            this.onProductSortChange();
                                        }
                                    }
                                })
                            ]);
                        },
                        render: (h, params) => {
                            return h("input", {
                                domProps: {
                                    value: params.row.productDisplayOrder
                                },
                                style: {
                                    textAlign: "center",
                                    width: 60 + "px",
                                    outline: "none"
                                },
                                on: {
                                    change: (event) => {
                                        try {
                                            let intVal = parseInt(event.target.value);
                                            if (intVal < 0) {
                                                intVal = 0;
                                            }
                                            params.row.productDisplayOrder = intVal;
                                        }
                                        catch (e) {
                                            event.target.value
                                                = params.row.productDisplayOrder;
                                        }
                                    }
                                }
                            });
                        }
                    },
                    {
                        title: "成品图",
                        align: "center",
                        render: (h, params) =>
                            singleImageRender(
                                h,
                                params.row.productFinishImageFile
                            )
                    },
                    {
                        title: "详情",
                        key: "action",
                        align: "center",
                        width: 80,
                        render: (h, params) => {
                            return h("div", [
                                h(
                                    "Button",
                                    {
                                        props: {
                                            type: "text",
                                            size: "small",
                                            shape: "circle"
                                        },
                                        on: {
                                            click: () => {
                                                this.onPopup(params.row);
                                            }
                                        }
                                    },
                                    "查看"
                                )
                            ]);
                        }
                    },
                    {
                        title: "操作",
                        key: "action",
                        align: "center",
                        width: 220,
                        render: (h, params) => {
                            return h("div", [
                                h(
                                    "Button",
                                    {
                                        props: {
                                            type: "text",
                                            size: "small",
                                            shape: "circle"
                                        },
                                        style: {
                                            display: this.$checkAccessArray([
                                                "B",
                                                "C"
                                            ])
                                                ? "inline-block"
                                                : "none"
                                        },
                                        on: {
                                            click: () => {
                                                this.onSave(params.row);
                                            }
                                        }
                                    },
                                    "保存排序"
                                ),
                                h(
                                    "Button",
                                    {
                                        props: {
                                            type: "text",
                                            size: "small",
                                            shape: "circle"
                                        },
                                        style: {
                                            display: this.$checkAccessArray([
                                                "B",
                                                "C"
                                            ])
                                                ? "inline-block"
                                                : "none"
                                        },
                                        on: {
                                            click: () => {
                                                this.onPopup(params.row);
                                                //this.$refs.productPopupEdit.initProductId();
                                            }
                                        }
                                    },
                                    "编辑"
                                ),
                                h(
                                    "Button",
                                    {
                                        props: {
                                            type: "text",
                                            size: "small",
                                            shape: "circle"
                                        },
                                        style: {
                                            display:
                                                this.$checkAccessArray([
                                                    "B",
                                                    "C"
                                                ]) && params.row.isShow == 1
                                                    ? "inline-block"
                                                    : "none"
                                        },
                                        on: {
                                            click: () => {
                                                this.updateProductForIsShow(
                                                    params.row,
                                                    0
                                                );
                                            }
                                        }
                                    },
                                    "隐藏"
                                ),
                                h(
                                    "Button",
                                    {
                                        props: {
                                            type: "text",
                                            size: "small",
                                            shape: "circle"
                                        },
                                        style: {
                                            display:
                                                this.$checkAccessArray([
                                                    "B",
                                                    "C"
                                                ]) && params.row.isShow == 0
                                                    ? "inline-block"
                                                    : "none"
                                        },
                                        on: {
                                            click: () => {
                                                this.updateProductForNotShow(
                                                    params.row,
                                                    1
                                                );
                                            }
                                        }
                                    },
                                    "取消隐藏"
                                ),
                                h(
                                    "Button",
                                    {
                                        props: {
                                            type: "text",
                                            size: "small",
                                            shape: "circle"
                                        },
                                        style: {
                                            display: this.$checkAccessArray([
                                                "B",
                                                "C"
                                            ])
                                                ? "inline-block"
                                                : "none"
                                        },
                                        on: {
                                            click: () => {
                                                this.deleteProduct(params.row);
                                            }
                                        }
                                    },
                                    "删除"
                                ),
                                h(
                                    "Button",
                                    {
                                        props: {
                                            type: "text",
                                            size: "small",
                                            shape: "circle"
                                        },
                                        style: {
                                            display: this.$checkAccessArray([
                                                "B",
                                                "S"
                                            ])
                                                ? "inline-block"
                                                : "none"
                                        },
                                        on: {
                                            click: () => {
                                                this.syncYSProduct(params.row.productUuid);
                                            }
                                        }
                                    },
                                    "同步ys"
                                )
                            ]);
                        }
                    }
                ],
                tableData: [],
                tableLoading: false,
                tableSearch: search.getSearchParams(),
                sarchCardShow: false,
                searchForm: [
                    {
                        label: "产品信息",
                        type: "Input",
                        value: "",
                        name: "concat(productName,productCode)",
                        sql: "like"
                    },
                    {
                        label: "苗场名称",
                        type: "Input",
                        value: "",
                        name: "seedFarmName",
                        sql: "like"
                    },
                    {
                        label: "苗场编号",
                        type: "Input",
                        value: "",
                        name: "seedFarmCode",
                        sql: "like"
                    },
                    {
                        label: "大类",
                        type: "Input",
                        value: "",
                        name: "mainCategoryName",
                        sql: "like"
                    },
                    {
                        label: "小类",
                        type: "Input",
                        value: "",
                        name: "subCategoryName",
                        sql: "like"
                    },
                    {
                        label: "形态",
                        type: "Input",
                        value: "",
                        name: "products.productForm",
                        sql: "like"
                    },
                    {
                        label: "规格",
                        type: "Input",
                        value: "",
                        name: "products.productSpec",
                        sql: "like"
                    }
                ]
            },
            selection: [],
            productUuids: [],
            productUuidsBathEdit: [],
            popupEditModalShow: false,
            popupEditModalBathShow: false,
            popupEditModalBaseBathShow: false,
            popupEditModalInsertTemplateShow: false,
            popupEditProductUuid: "",
            popupEditproductCode: "",
            popupEditResource: getResource(),
            blockDistModal: {
                show: false,
                productUuid: "",
                table: {
                    columns: [
                        { title: "类型", key: "blockType", align: "center" },
                        { title: "省", key: "provinceName", align: "center" },
                        { title: "市", key: "cityName", align: "center" },
                        { title: "区", key: "distName", align: "center" }
                    ],
                    rows: []
                },
                cityOptions: [],
                distOptions: [],
                form: {
                    provinceUuid: "",
                    cityUuid: "",
                    distUuid: "",
                    blockType: ""
                }
            },
            commissionDistModal: {
                show: false,
                productUuid: "",
                seedFarmUuid: "",
                table: {
                    columns: [
                        { title: "省份", key: "provinceName", align: "center" },
                        { title: "城市", key: "cityName", align: "center" },
                        { title: "区域", key: "distName", align: "center" },
                        {
                            title: "类型",
                            key: "commissionType",
                            align: "center"
                        },
                        {
                            title: "提成",
                            key: "commission",
                            align: "right",
                            render: (h, params) =>
                                h("span", {}, params.row.commission + "%")
                        },
                        {
                            title: "操作",
                            key: "action",
                            align: "center",
                            render: (h, params) => {
                                return h("div", [
                                    h(
                                        "Button",
                                        {
                                            props: {
                                                type: "text",
                                                size: "small",
                                                shape: "circle"
                                            },
                                            style: {},
                                            on: {
                                                click: () => {
                                                    this.onRemoveCommission(
                                                        params.index
                                                    );
                                                }
                                            }
                                        },
                                        "删除"
                                    )
                                ]);
                            }
                        }
                    ],
                    rows: []
                },
                cityOptions: [],
                distOptions: [],
                form: {
                    provinceUuid: "",
                    cityUuid: "",
                    distUuid: "",
                    commissionType: "",
                    commissionValue: 0
                }
            },
            externalCustomerUsers: [],
            privateSaleModal: {
                show: false,
                productUuid: "",
                customerUuid: "",
                table: {
                    columns: [
                        { title: "会员号", key: "userName", align: "center" },
                        {
                            title: "会员名",
                            key: "userPersonName",
                            align: "center"
                        },
                        { title: "电话", key: "userPhone", align: "center" },
                        {
                            title: "操作",
                            key: "action",
                            align: "center",
                            render: (h, params) => {
                                return h("div", [
                                    h(
                                        "Button",
                                        {
                                            props: {
                                                type: "text",
                                                size: "small",
                                                shape: "circle"
                                            },
                                            style: {},
                                            on: {
                                                click: () => {
                                                    this.privateSaleModal.table.rows.splice(
                                                        params.index,
                                                        1
                                                    );
                                                }
                                            }
                                        },
                                        "删除"
                                    )
                                ]);
                            }
                        }
                    ],
                    rows: []
                }
            },
            displayOrderModal: {
                show: false,
                productUuid: "",
                productDisplayOrder: 0
            }
        };
    },
    // beforeRouteLeave(to, from, next) {
    //     this.mainTable.tableData = [];
    //     this.blockDistModal.table.rows = [];
    //     this.privateSaleModal.table.rows = [];
    //     this.$destroy();
    //     next();
    // },
    computed: {
        personName() {
            return this.$store.state.user.personName;
        },
        personType() {
            return this.$store.state.user.personType;
        },
        productOrderIcon() {
            if (this.productOrder == 1) {
                return "md-arrow-round-up";
            }
            else if (this.productOrder == 2) {
                return "md-arrow-round-down";
            }
            else {
                return "md-reorder";
            }
        }
    },
    created() {
        if (this.readOnly) {
            const findIndex = this.mainTable.tableColumns.findIndex(
                (c) => c.title === "操作"
            );
            if (findIndex >= 0 && !this.$checkAccessArray(["S"])) {
                this.mainTable.tableColumns.splice(findIndex, 1);
            }
        }
        else {
            const findIndex = this.mainTable.tableColumns.findIndex(
                (c) => c.title === "详情"
            );
            if (findIndex >= 0) {
                this.mainTable.tableColumns.splice(findIndex, 1);
            }
        }
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.getMainTableRecords();
            this.initPopupData();
        },
        initPopupData() {
            this.innerSpin = true;
            pageInit4ProductEdit().then((res) => {
                this.innerSpin = false;
                if (res.code === 0) {
                    setResource(this.popupEditResource, res);
                }
            });
        },
        onSelectionChange(selection) {
            this.productUuidsBathEdit = selection.map(
                (item) => item.productUuid
            );
            //console.log(this.productUuidsBathEdit)
        },
        onExport() {
            const searchCondition = search.deepClone(
                this.mainTable.tableSearch
            );
            searchCondition.limit.enable = false;
            searchCondition.excelExport.enable = true;
            searchCondition.excelExport.columns = this.mainTable.tableColumns
                .filter((col) => col.excel)
                .map((col) => {
                    return {
                        key: col.key,
                        title: col.title
                    };
                });

            this.mainTable.tableLoading = true;
            getProductList(searchCondition).then((res) => {
                this.mainTable.tableLoading = false;
                if (res.code === 0) {
                    let url = DOWNLOAD_SERVER + res.data.exportFileName;
                    this.$downLoadFile(url);
                    // window.open(FILE_SERVER + res.data.exportFileName, "_blank");
                }
            });
        },
        updateProductForIsShow(row, isShowValue) {
            this.mainTable.tableLoading = true;
            updateProductForShow({
                productUuid: row.productUuid,
                isShow: isShowValue
            }).then((res) => {
                if (res.code === 0) {
                    this.$Message.info("操作成功!");
                    this.getMainTableRecords();
                }
                else {
                    this.mainTable.tableLoading = false;
                }
            });
        },
        batchUpdateProductForNotShow() {
            this.selection
                = this.$refs.mainTable.$refs.standPaginationTable.getSelection();
            if (this.selection.length == 0) {
                this.$Modal.error({
                    title: "请先选择产品"
                });
                return;
            }
            this.productUuids = this.selection.map((e) => e.productUuid);
            this.mainTable.tableLoading = true;
            updateProductForShow({ productUuids: this.productUuids }).then(
                (res) => {
                    if (res.code === 0) {
                        this.getMainTableRecords();
                    }
                    else {
                        this.mainTable.tableLoading = false;
                    }
                }
            );
        },
        updateProductForNotShow(row, isShowValue) {
            this.mainTable.tableLoading = true;
            updateProductForShow({
                productUuid: row.productUuid,
                isShow: isShowValue
            }).then((res) => {
                if (res.code === 0) {
                    this.getMainTableRecords();
                }
                else {
                    this.mainTable.tableLoading = false;
                }
            });
        },
        deleteProduct(row) {
            this.mainTable.tableLoading = true;
            deleteProductByUuid({ productUuid: row.productUuid }).then(
                (res) => {
                    if (res.code === 0) {
                        this.getMainTableRecords();
                    }
                    else {
                        this.mainTable.tableLoading = false;
                    }
                }
            );
        },
        showAllProducts() {
            this.isShowAllPros = false;
            this.getMainTableRecords();
        },
        getMainTableRecords(reset = false) {
            this.mainTable.tableLoading = true;

            if (reset) {
                search.globalResetSearch(this.mainTable.tableSearch);
            }
            if (this.isShowAllPros) {
                search.globalRemoveFilterConditionKey(
                    this.mainTable.tableSearch,
                    "isShow"
                );
                this.mainTable.tableSearch.filters.enable = true;
                this.mainTable.tableSearch.filters.conditions.push({
                    name: "isShow",
                    type: "eq",
                    value: 1
                });
            }
            else {
                search.globalRemoveFilterConditionKey(
                    this.mainTable.tableSearch,
                    "isShow"
                );
                this.mainTable.tableSearch.filters.enable = true;
                this.mainTable.tableSearch.filters.conditions.push({
                    name: "isShow",
                    type: "eq",
                    value: 0
                });
            }
            //设置排序条件
            this.setOrderCondition();
            getProductList(this.mainTable.tableSearch).then((res) => {
                if (res.code === 0) {
                    this.mainTable.tableData = res.data.records;
                    search.globalSetFilterRecordCount(
                        this.mainTable.tableSearch,
                        res.data.filterRecordCount
                    );
                }

                this.mainTable.tableLoading = false;
            });
        },
        //设置排序条件
        //设置排序条件
        setOrderCondition() {
            console.log('设置排序条件，当前productOrder:', this.productOrder);

            this.mainTable.tableSearch.order.enable = false;
            this.mainTable.tableSearch.order.conditions = [];
            this.mainTable.tableSearch.order.conditions.push({
                name: "CASE WHEN products.productDisplayOrder = 0 THEN 1 ELSE 0 END",
                type: "asc"
            });
            if (this.productOrder == 1) {
                this.mainTable.tableSearch.order.conditions.push({
                    name: "productDisplayOrder",
                    type: "asc"
                });
                this.mainTable.tableSearch.order.enable = true;
                console.log('设置升序排序');
            }
            else if (this.productOrder == 2) {
                this.mainTable.tableSearch.order.conditions.push({
                    name: "productDisplayOrder",
                    type: "desc"
                });
                this.mainTable.tableSearch.order.enable = true;
                console.log('设置降序排序');
            }
            else {
                console.log('默认排序，不设置排序条件');
            }
            this.mainTable.tableSearch.order.conditions.push({
                name: "products.productCode",
                type: "asc"
            });


            

            console.log('当前排序配置:', JSON.stringify(this.mainTable.tableSearch.order, null, 2));
        },
        onCreate() {
            this.popupEditProductUuid = "";
            this.popupEditModalShow = true;
            this.$refs.productPopupEdit.initProductId();
        },
        onBathEdit() {
            this.popupEditProductUuid = "";
            this.popupEditModalBathShow = true;
        },
        onBaseBathEdit() {
            this.popupEditProductUuid = "";
            this.popupEditModalBaseBathShow = true;
        },
        onCreateBytemplate() {
            this.popupEditModalInsertTemplateShow = true;
        },
        onUpdate(row) {
            this.$router.push({
                name: "product-edit",
                query: {
                    productUuid: row.productUuid
                }
            });
        },
        onSetTop(row) {
            this.innerSpin = true;
            setProductTop({ productUuid: row.productUuid }).then((res) => {
                this.innerSpin = false;
                if (res.code === 0) {
                    this.getMainTableRecords();
                }
            });
        },
        onPopup(row) {
            this.popupEditProductUuid = row.productUuid;
            this.popupEditproductCode = row.productCode;
            this.popupEditModalShow = true;
        },
        onShowSpecialCommission(row) {
            const tableSearch = search.getSearchParams({
                closeAllConditions: true
            });
            tableSearch.productUuid = row.productUuid;
            tableSearch.seedFarmUuid = row.productRelateSeedFarmUuid;

            getProductSpecialCommission(tableSearch).then((res) => {
                if (res.code === 0) {
                    this.commissionDistModal.productUuid = row.productUuid;
                    this.commissionDistModal.seedFarmUuid = row.productRelateSeedFarmUuid;
                    this.commissionDistModal.table.rows = res.data.commissions;
                    this.commissionDistModal.show = true;
                }
            });

            this.commissionDistModal.show = true;
        },
        onSetSpecailCommission() {
            const submitData = {
                productUuid: this.commissionDistModal.productUuid,
                seedFarmUuid: this.commissionDistModal.seedFarmUuid,
                commissions: this.commissionDistModal.table.rows
            };

            this.innerSpin = true;
            saveProductSpecialCommission(submitData)
                .then((res) => {
                    this.innerSpin = false;
                    if (res.code === 0) {
                        this.$Modal.success({
                            title: "保存成功",
                            onOk: () => {
                                this.commissionDistModal.show = false;
                            }
                        });
                    }
                })
                .catch(() => {
                    this.innerSpin = false;
                });
        },
        onAddCommission() {
            if (this.commissionDistModal.form.distUuid) {
                const exists = this.commissionDistModal.table.rows.find(
                    (r) =>
                        r.distUuid === this.commissionDistModal.form.distUuid
                        && r.commissionType === this.commissionDistModal.form.commissionType
                );
                if (!exists) {
                    const province = this.popupEditResource.provinceOptions.find(
                        (o) =>
                            o.regionUuid === this.commissionDistModal.form.provinceUuid
                    );
                    const city = this.commissionDistModal.cityOptions.find(
                        (o) =>
                            o.regionUuid === this.commissionDistModal.form.cityUuid
                    );
                    const dist = this.commissionDistModal.distOptions.find(
                        (o) =>
                            o.regionUuid
                            === this.commissionDistModal.form.distUuid
                    );
                    this.commissionDistModal.table.rows.push({
                        provinceUuid:
                            this.commissionDistModal.form.provinceUuid,
                        provinceName: province.regionName,
                        cityUuid: this.commissionDistModal.form.cityUuid,
                        cityName: city.regionName,
                        distUuid: this.commissionDistModal.form.distUuid,
                        distName: dist.regionName,
                        commissionType:
                            this.commissionDistModal.form.commissionType,
                        commission:
                            this.commissionDistModal.form.commissionValue
                    });
                }
            }
        },
        onRemoveCommission(index) {
            this.commissionDistModal.table.rows.splice(index, 1);
        },
        popupSubmitFinish(formEditMode, productUuid, productCode) {
            this.getMainTableRecords();
            if (formEditMode == FORM_EDIT_MODE_CREATE) {
                this.popupEditProductUuid = productUuid;
                this.popupEditproductCode = productCode;
                this.$nextTick(() => {
                    this.$refs.productPopupEdit.setProductPopupEdit();
                });
            }
            else {
                this.$refs.productPopupEdit.setProductPopupEdit();
            }
        },
        onShowBlockModal(row) {
            const tableSearch = search.getSearchParams({
                closeAllConditions: true
            });
            tableSearch.productUuid = row.productUuid;

            getProductBlockDist(tableSearch).then((res) => {
                if (res.code === 0) {
                    this.blockDistModal.productUuid = row.productUuid;
                    this.blockDistModal.table.rows = res.data.records;
                    this.blockDistModal.show = true;
                }
            });
        },
        onSetProductBlock() {
            const submitData = {
                productUuid: this.blockDistModal.productUuid,
                blockLines: this.blockDistModal.table.rows
            };

            this.innerSpin = true;
            saveProductBlockDist(submitData)
                .then((res) => {
                    this.innerSpin = false;
                    if (res.code === 0) {
                        this.$Modal.success({
                            title: "保存成功",
                            onOk: () => {
                                this.blockDistModal.show = false;
                            }
                        });
                    }
                })
                .catch(() => {
                    this.innerSpin = false;
                });
        },
        onCommissionProvinceChange(provinceUuid) {
            this.commissionDistModal.form.cityUuid = "";
            this.commissionDistModal.form.distUuid = "";
            this.commissionDistModal.distOptions = [];
            this.commissionDistModal.cityOptions = this.popupEditResource.allRegionInfo.filter((r) =>
                r.regionType === 2 &&r.regionParentUuid === provinceUuid
            );
        },
        onCommissionCityChange(cityUuid) {
            this.commissionDistModal.form.distUuid = "";
            this.commissionDistModal.distOptions = this.popupEditResource.allRegionInfo.filter(
                (r) => r.regionType === 3 && r.regionParentUuid === cityUuid
            );
        },
        onBlockProvinceChange(provinceUuid) {
            this.blockDistModal.form.cityUuid = "";
            this.blockDistModal.form.distUuid = "";
            this.blockDistModal.distOptions = [];
            this.blockDistModal.cityOptions
                = this.popupEditResource.allRegionInfo.filter(
                    (r) =>
                        r.regionType === 2 && r.regionParentUuid === provinceUuid
                );
        },
        onBlockCityChange(cityUuid) {
            this.blockDistModal.form.distUuid = "";
            this.blockDistModal.distOptions = this.popupEditResource.allRegionInfo.filter(
                (r) => r.regionType === 3 && r.regionParentUuid === cityUuid
            );
        },
        onAddProductBlock() {
            if (
                this.blockDistModal.form.distUuid !== ""
                && this.blockDistModal.form.blockType !== ""
            ) {
                const find = this.blockDistModal.table.rows.find((item) => {
                    return (
                        item.distUuid === this.blockDistModal.form.distUuid
                        && item.blockType === this.blockDistModal.form.blockType
                    );
                });
                if (!find) {
                    const dist = this.popupEditResource.allRegionInfo.find(
                        (item) =>
                            item.regionUuid
                            === this.blockDistModal.form.distUuid
                    );

                    this.blockDistModal.table.rows.push({
                        distUuid: this.blockDistModal.form.distUuid,
                        distName: dist.regionName,
                        blockType: this.blockDistModal.form.blockType
                    });
                }
            }
        },
        onShowPrivateSale(row) {
            this.privateSaleModal.productUuid = row.productUuid;

            const submitData = {
                productUuid: row.productUuid
            };

            getProductPrivateCustomer(submitData).then((res) => {
                if (res.code === 0) {
                    this.privateSaleModal.table.rows = res.data;
                    this.privateSaleModal.show = true;
                }
            });
        },
        onAddPrivateSale() {
            if (this.privateSaleModal.customerUuid === "") {
                return;
            }

            const findCustomer = this.externalCustomerUsers.find(
                (c) => c.userUuid === this.privateSaleModal.customerUuid
            );
            if (!findCustomer) {
                return;
            }

            const exists = this.privateSaleModal.table.rows.find(
                (r) => r.userUuid === this.privateSaleModal.customerUuid
            );
            if (!exists) {
                this.privateSaleModal.table.rows.push({
                    userUuid: findCustomer.userUuid,
                    userName: findCustomer.userName,
                    userPersonName: findCustomer.userPersonName,
                    userPhone: findCustomer.userPhone
                });
            }
        },
        onUpdatePrivateSale() {
            const submitData = {
                productUuid: this.privateSaleModal.productUuid,
                customerUuidList: this.privateSaleModal.table.rows.map((r) => {
                    return r.userUuid;
                })
            };

            this.innerSpin = true;
            updateProductPrivateSale(submitData)
                .then((res) => {
                    this.innerSpin = false;
                    if (res.code === 0) {
                        this.$Modal.success({
                            title: "设置成功",
                            onOk: () => {
                                this.privateSaleModal.show = false;
                            }
                        });
                    }
                })
                .catch(() => {
                    this.innerSpin = false;
                });
        },
        hideAllProducts(type) {
            let selection = this.$refs.mainTable.$refs.standPaginationTable.getSelection();
            if (selection.length === 0) {
                this.$Modal.error({
                    title: "未勾选记录"
                });
                return;
            }

            let data = {
                productUuids: selection.map((e) => {
                    return e.productUuid;
                }),
                enable: type
            };
            console.log(data);
        },
        onSave(row) {
            this.mainTable.tableLoading = true;
            updateProductDisplayOrder({
                productUuid: row.productUuid,
                productDisplayOrder: row.productDisplayOrder
            }).then((res) => {
                if (res.code === 0) {
                    this.getMainTableRecords();
                }
                else {
                    this.mainTable.tableLoading = false;
                }
            });
        },
        onProductSortChange() {
            this.productOrder = (this.productOrder + 1) % 3;
            this.getMainTableRecords();
        },
        insertByTemplate() {
            this.popupEditModalShow = true;
        },
        syncYSProduct(productUuid){
            let data = { productUuid: productUuid };
            syncYsProduct(data).then((res) => {
                if (res.code === 0) {
                    this.$Modal.success({
                        title: "同步成功"
                    });
                }
            });
        }
    }
};
</script>

<style scoped lang="less">
@titleHeight: 25px;

.border {
    border: 1px solid #c9c9c9;
    margin-bottom: 5px;
    padding: 5px 5px 5px 5px;
}

.title {
    height: @titleHeight;

    .text {
        font-weight: bold;
        float: left;
        line-height: @titleHeight;
    }

    .action {
        float: right;
    }
}
</style>
